<script>
import axios from "axios";
// import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar" style="background-color: #0262a7;">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="40" style="border-radius: 50px;" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="40" style="border-radius: 50px;" />
              </span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo != 0">
                <img :src="getFiles(userData.logo)" height="60" style="border-radius: 50px;" />
              </span>
              <span v-else>
                <img src="@/assets/images/logo.png" height="60" style="border-radius: 50px;" />
              </span>
            </span>
          </router-link>
        </div>

        <span class="h3 text-white"><br> {{ userData.business }}</span> <span class="h6 ms-2 mt-3 text-white"><br>{{
          userData.location }}</span>
        <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"><i class="fa fa-fw fa-bars"></i></button>
      </div>

      <div class="d-flex">


        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content><i class="fas fa-clipboard"></i> Reports<i
                class="mdi mdi-chevron-down"></i></template>
            <div class="row">
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Saving Reports</h5>
                <ul class="list-unstyled megamenu-list" v-show="userData.permissions['savings_report'] == 1">
                  <li><router-link to="/savings-per-member">Savings Per Member</router-link></li>
                  <li><router-link to="/withdraws-per-member">Withdraws Per Member</router-link></li>
                  <li><router-link to="/shares-per-member">Shares Per Member</router-link></li>
                  <li><router-link to="/monthly-savings-analysis">Monthly Savings Analysis</router-link></li>
                  <li><router-link to="/monthly-withdraws-analysis">Monthly Withdraws Analysis</router-link></li>
                  <li><router-link to="/monthly-share-analysis">Monthly Shares Analysis</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Loan Reports</h5>
                <ul class="list-unstyled megamenu-list" v-show="userData.permissions['loans_report'] == 1">
                  <li><router-link to="/loans-per-member">Loans Per Member</router-link></li>
                  <li><router-link to="/loan-payment-report">Loan Payment Reports</router-link></li>
                  <li><router-link to="/written-off-loans">Written Off Loans</router-link></li>
                  <li><router-link to="/due-loans">Due Loans</router-link></li>
                  <li><router-link to="/loan-per-products">Loans Per Loan Products</router-link></li>
                  <li><router-link to="/loan-monthly-report">Monthly Loan Analysis</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Performance Reports</h5>
                <ul class="list-unstyled megamenu-list" v-show="userData.permissions['performance_reports'] == 1">
                  <li><router-link to="/savings-per-user">Savings Per User</router-link></li>
                  <li><router-link to="/withdraws-per-user">Withdraws Per User</router-link></li>
                  <li><router-link to="/shares-per-user">Shares Per User</router-link></li>
                  <li><router-link to="/loans-per-user">Loans Per User</router-link></li>
                  <li><router-link to="/transactions-report">Transactions Report</router-link></li>
                  <li><router-link to="/expenses-report">Expenses Report</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Other Reports</h5>
                <ul class="list-unstyled megamenu-list" v-show="userData.permissions['other_reports'] == 1">
                  <li><router-link to="/inactive-accounts">Inactive Member Accounts</router-link></li>
                  <li><router-link to="/withdraw-charges-report">Withdraw Charges Report</router-link></li>
                  <li><router-link to="/loan-interests-report">Loan Interests Report</router-link></li>
                  <li><router-link to="/loan-charges-report">Loan Charges Report</router-link></li>
                  <li><router-link to="/membership-fees-port">Membership Fees Report</router-link></li>
                  <li><router-link to="/income-and-expenditure">Income & Expenditure</router-link></li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>


        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen"><i
              class="bx bx-fullscreen"></i></button>
        </div>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img class="rounded-circle header-profile-user" src="@/assets/images/user.png" />
            <span class="d-none d-xl-inline-block ms-1">{{ userData.username }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
